import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface Prayer {
  id: string;
  author_id: string;
  content: string;
  created_at: string;
  prayer_count?: number;
  praying_users?: string[];
  author_name?: string;
}

export const usePrayers = () => {
  return useQuery<Prayer[]>({
    queryKey: ['prayers'],
    queryFn: async () => {
      const { data: posts, error } = await supabase
        .from('wall_posts')
        .select('*')
        .eq('type', 'prayer')
        .order('created_at', { ascending: false })
        .limit(100);
      if (error) throw error;

      // collect author names
      const authorIds: string[] = [];
      (posts ?? []).forEach((p: any) => {
        if (p.author_id && !authorIds.includes(p.author_id)) authorIds.push(p.author_id);
      });
      let usersMap: Record<string, string> = {};
      if (authorIds.length) {
        const { data: users } = await supabase
          .from('users')
          .select('id, full_name')
          .in('id', authorIds);
        users?.forEach((u) => {
          usersMap[u.id as string] = (u.full_name as string) || '';
        });
      }

      const enriched = (posts ?? []).map((p: any) => ({
        ...p,
        author_name: usersMap[p.author_id] ?? p.author_id,
      }));
      return enriched as Prayer[];
    },
  });
};
